export default "__VITE_ASSET__CBWWFE0j__"